/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  GetSupplyStepperService,
  IGetSupplyStepperMethods,
  ISupplierOrgMethods,
  SupplierOrgService,
  IFormatPreviewDetailMethods,
  FormatPreviewDetailService,
  IFormatOrgListMethods,
  FormatOrgListService,
  IFormatComplFormMethods,
  FormatComplFormService,
} from './components';

export type SupplyStepperAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IGetSupplyStepperMethods &
  ISupplierOrgMethods &
  IFormatPreviewDetailMethods &
  IFormatOrgListMethods &
  IFormatComplFormMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    new GetSupplyStepperService(),
    new SupplierOrgService(),
    new FormatPreviewDetailService(),
    new FormatOrgListService(),
    new FormatComplFormService(),
  ];
};

export const getAgent = () => {
  return createAgent<SupplyStepperAgent>({
    plugins: getPlugins(),
  });
};
